export default __webpack_public_path__ + "static/media/Green0003.8b682ca5.png";